import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const Statements = lazyLoad(
    () => import('./index'),
    module => module.Statements,
    { fallback: <LoadingSpinner /> },
);
